let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h0uBE")).then(() => parcelRequire('74ATO'));